<template>
  <layout :loading="loading">
    <template v-slot:content>
      <div class="container mt-4">
        <t-alert variant="success" class="my-2" :show="dinnerUpdated">
          {{ $t('join_dinner_updated') }}
        </t-alert>
        <form class="flex flex-col mb-4 m-4 md:mx-24" @submit="onSubmit">
          <div class="flex flex-row items-center mb-4">
            <label class="w-48 font-semibold">{{ $t('is_join_dinner_enabled') }}</label>
            <t-toggle v-model="isJoinDinnerEnabled" />
          </div>

          <div class="flex flex-col mb-4">
            <label class="w-48 font-semibold mb-2">{{ $t('join_dinner_range') }}</label>
            <t-input
              :disabled='!isJoinDinnerEnabled'
              class="flex-grow"
              v-model="joinDinnerRange"
              placeholder="16:00-17:30"
            ></t-input>
          </div>
          
          <div>
            <t-button class="mt-4" variant="primary" :disabled="loading" type="submit">
              {{ $t("save") }}
            </t-button>
          </div>
        </form>
      </div>
    </template>
  </layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { actions, getters } from "@/constants/state";
import Layout from "@/components/Layout.vue";

export default {
  components: { Layout },
  data: () => ({
    loading: false,
    isJoinDinnerEnabled: false,
    dinnerUpdated: false,
    joinDinnerRange: '16:00-17:30',
  }),
  async mounted() {
    this.loading = true;
    try {
      const data = await this.getDomain;
      this.isJoinDinnerEnabled = data.is_join_dinner_enabled,
      this.joinDinnerRange = data.join_dinner_range
    } catch (error) {
      console.error("DEBUG: JoinDinner Form", error);
    }
    this.loading = false;
  },
  methods: {
    ...mapActions({
      updateJoinDinner: actions.JOIN_DINNER_UPDATE_ACTION,
    }),
    async onSubmit(e) {
      this.dinnerUpdated = false;
      e.preventDefault();
      this.loading = true;
      try {
        const domain = await this.getDomain;
        await this.updateJoinDinner({
          locationId: domain.horeca_location_id,
          isJoinDinnerEnabled: this.isJoinDinnerEnabled ? 1 : 0,
          joinDinnerRange: this.joinDinnerRange
        })
        this.dinnerUpdated = true;
      } catch (error) {
        this.dinnerUpdated = false;
        console.error("DEBUG: onSubmit", error);
      }
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters({
      getDomain: getters.DOMAIN_GETTER
    })
  }
};
</script>
